import { FindAllReviewablePtMembershipsResponseDto } from '#types/rates';
import { Item } from './Item';

interface ItemListProps {
  selectedMembership: string[];
  setSelectedMembership: React.Dispatch<React.SetStateAction<string[]>>;
  data: FindAllReviewablePtMembershipsResponseDto[] | undefined;
}
export const ItemList = ({
  selectedMembership,
  data,
  setSelectedMembership
}: ItemListProps) => {
  if (!data) {
    return null;
  }

  return (
    <div>
      {data.length === 0 && (
        <div className="w-full h-[102px] px-5 py-10 rounded-lg justify-center items-center gap-2.5 inline-flex">
          <div className="text-[#938f9e] text-[17px] font-medium font-['Pretendard Variable'] leading-snug">
            리뷰 요청 가능한 수강권이 없습니다.
          </div>
        </div>
      )}

      {data.length > 0 && (
        <div className="flex flex-col gap-12 w-full">
          {data.map(membership => (
            <Item
              selected={selectedMembership.includes(
                membership.confirmationFormId
              )}
              key={membership.confirmationFormId}
              onClick={() => {
                if (
                  selectedMembership.includes(membership.confirmationFormId)
                ) {
                  setSelectedMembership(prev =>
                    prev.filter(id => id !== membership.confirmationFormId)
                  );
                  return;
                }

                setSelectedMembership(prev => [
                  ...prev,
                  membership.confirmationFormId
                ]);
              }}
              {...membership}
            />
          ))}
        </div>
      )}
    </div>
  );
};
